export enum PUBLICATION_URL {
  ENOVA = 'https://tiendaenova.com.ar',
  NOVASTORE = 'https://novastore.ar',
  DETECNOLOGIA = 'https://detecnologia.com.ar',
  PIPESTORE = 'https://pipe.store'
}